// BEN_NOTE same idea here as actionTypes.
// we'll delete most of this and genericize it as much as possible.
// this hasn't been integrated yet, either

import actionTypes from './actionTypes';
import Immutable, {mergeDeep, List, Map, Set, OrderedMap} from 'immutable';

export default function mainReducer(state, action) {
  // console.log('mainReducer action:');
  // console.log(action);
  try {
    switch (action.type) {
      case actionTypes.SET_USER_SELECTION:
        window.localStorage.setItem(action.payload.name, action.payload.value);
        // console.debug(`window.localStorage set and now get ${action.payload.name}: `);
        // console.debug(window.localStorage.getItem(action.payload.name));
        return state.setIn(['browserScope', action.payload.name], action.payload.value);
      case actionTypes.DELETE_USER_SELECTION:
        window.localStorage.removeItem(action.payload.name);
        return state.setIn(['browserScope', action.payload.name], action.payload.value);
      case actionTypes.SHOW_COMPLEX_MODAL:
        return (
          state
            // this allows us to pass a string for which modal to show
            .set('showComplexModal', action.payload ? action.payload : true)
        );
      case actionTypes.SET_IN_REDUX:
        try {
          if (typeof action.payload.path === 'string') {
            action.payload.path = action.payload.path.split('.');
          }
          return state.mergeDeep(action.payload.path,
              Immutable.fromJS(action.payload.data));
        } catch (e) {
          //TODO - don't try/catch to get here.  Instead add an if above
          return state.setIn(action.payload.path, action.payload.data);
        }
      default:
        return state;
    }
  } catch (e) {
    console.error('error in mainReducer: ');
    console.error(e);
  }
}
